<div class='col'>
  <dx-slider
    [min]='0'
    [max]='100'
    [value]='value'
    [showRange]='false'
    [readOnly]='true'>{{value}}</dx-slider>
</div>
